'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trunc = trunc;
function trunc(str, numChar, useWordBoundary) {
  var toLong = str.length > numChar;
  var s_ = toLong ? str.substr(0, numChar - 1) : str;
  s_ = useWordBoundary && toLong ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
  return toLong ? s_ + '\u2026' : s_;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/string.js
// module id = 341
// module chunks = 0